export default __webpack_public_path__ + "265f7324a7db0b01e4d4819c3a28df4c.png";